import { Directive, ElementRef, HostBinding, inject } from '@angular/core';

@Directive({
  selector: '[procureValueItem]',
})
export class ValueItemDirective {
  readonly elem = inject(ElementRef);

  private _class: string = 'label-value-list__value';

  @HostBinding('class')
  get class(): string {
    return this._class;
  }
}
